import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material';

// Note: may need to build out a common solution that avoids using @mui/lab
export const StyledLoadingButton = styled(LoadingButton)`
    .MuiLoadingButton-loadingIndicatorCenter {
        color: ${(props) => props.theme.palette.common.white};
    }
`;
